module.exports = __webpack_public_path__ + "static/media/DSC09946.9d7531fa.jpg";